module.exports = __webpack_public_path__ + "static/media/envelope-block.0c5e9f7b.svg";